import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade active show",
  role: "tabpanel"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex d-md-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "My Communications")
  ])
], -1)
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-bullhorn fa-4x" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = {
  class: "table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9",
  "aria-label": "A list of all your communications."
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "d-none border-gray-200 fs-5 fw-bold bg-lighten" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Title"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "d-none d-md-table-cell"
    }, "Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "d-none d-md-table-cell"
    }, "Type")
  ])
], -1)
const _hoisted_9 = { class: "fw-6 fw-bold text-gray-600" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex flex-column pe-4" }
const _hoisted_12 = { class: "mb-1 text-white" }
const _hoisted_13 = { class: "text-gray-800 d-flex" }
const _hoisted_14 = { class: "d-block d-md-none ms-auto" }
const _hoisted_15 = { class: "d-none d-md-table-cell" }
const _hoisted_16 = { class: "d-none d-md-flex" }
const _hoisted_17 = { class: "d-md-none" }
const _hoisted_18 = {
  key: 0,
  class: "text-gray-800 fst-italic"
}
const _hoisted_19 = { class: "d-none d-md-table-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_CommunicationViewerModal = _resolveComponent("CommunicationViewerModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.communications.length === 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "No communications in the last 7 days"
            }, {
              image: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _hoisted_8,
                _withDirectives((_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.communications, (communication) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: communication.communicationId,
                      class: "cursor-pointer",
                      onClick: ($event: any) => (_ctx.viewCommunication(communication))
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(communication.title), 1),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", null, _toDisplayString(communication.entityName), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getFriendlyDateTime(communication.lastUpdated)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getFriendlyDateTime(communication.lastUpdated)), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getShortFriendlyDateTime(communication.lastUpdated)), 1),
                        (communication.authorFirstName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(communication.authorFirstName) + " " + _toDisplayString(communication.authorLastName), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge badge-light-${_ctx.getCommunicationType(communication.type).class} text-white fs-7 fw-bolder`)
                        }, _toDisplayString(_ctx.getCommunicationType(communication.type).name), 3)
                      ])
                    ], 8, _hoisted_10))
                  }), 128))
                ])), [
                  [_directive_loading, _ctx.isLoading]
                ])
              ])
            ]))
      ])
    ]),
    _createVNode(_component_CommunicationViewerModal, { ref: "communicationViewerModal" }, null, 512)
  ]))
}